import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare, Copy } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Button, Typography, Stack, Tooltip, Tab, Tabs, CircularProgress } from "@mui/material";
import ShareIcon from '../../icons/share.png';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon
} from "react-share";
import styles from './cards.module.scss';
import { ReactComponent as Share } from '../../icons/share.svg';
import QRCode from 'qrcode.react';
import { getShareLink } from "../../utils/profile-utils";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


const ShareModal = observer(({ cardId, viewCard }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [link, setLink] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyClick = () => {
      navigator.clipboard.writeText(link);
      setIsCopied(true);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        async function getLink() {
            setLoading(true);
            const data = await getShareLink(cardId);
            setLink(data);
            setLoading(false);
        }


        if (show && !link) {
            getLink();
        }
    }, [cardId, link, show])


    return (
        <>
            {viewCard ?
                <Tooltip title="Share">
                    <IconButton
                        variant="contained"
                        className={styles.small}
                        onClick={() => setShow(true)}
                    >
                        <Share width={20} height={20} />
                    </IconButton>
                </Tooltip>
                :
                <Button onClick={() => setShow(true)} color='greyPrimary'>
                    <img src={ShareIcon} alt='Share' />
                    Share
                </Button>
            }
            <Dialog fullWidth maxWidth='sm' open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            >
                <DialogTitle>
                    Share Card
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    {loading ?
                        <CircularProgress />
                        :
                        <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange}>
                                    <Tab label="Link" />
                                    <Tab label="QR code" />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                <Box sx={{ textAlign: 'right', mb: 3 }}>
                                    <Box className={styles.urlBox}>
                                        {link}
                                    </Box>
                                    <Button
                                        variant="contained"
                                        endIcon={<Copy
                                            size="24"
                                            variant="Bulk"
                                        />} color="primary"
                                        onClick={handleCopyClick}
                                    >
                                        {isCopied ? 'Copied!' : 'Copy'}
                                    </Button>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography fontSize={14} sx={{ mr: 2 }}>Share on Social</Typography>
                                    <Stack direction="row" spacing={2}>
                                        <FacebookShareButton url={`${window.location.protocol}//${window.location.hostname}/card/${cardId}`}>
                                            <FacebookIcon size={24} round />
                                        </FacebookShareButton>
                                        <TwitterShareButton url={`${window.location.protocol}//${window.location.hostname}/card/${cardId}`}>
                                            <TwitterIcon size={24} round />
                                        </TwitterShareButton>
                                        <LinkedinShareButton url={`${window.location.protocol}//${window.location.hostname}/card/${cardId}`}>
                                            <LinkedinIcon size={24} round />
                                        </LinkedinShareButton>
                                    </Stack>
                                </Box>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <Box>
                                    <QRCode value={`${window.location.protocol}//${window.location.hostname}/card/${cardId}`} />
                                </Box>
                            </TabPanel>
                        </>
                    }
                </DialogContent>
            </Dialog>
        </ >
    );
});

export default ShareModal;
